import React from "react";
import styled from "styled-components";

const MoleculeImageContentInfoBoard = ({
  title = "",
  imageUrl = "",
  logo = null,
  orientation = "landscape",
  headerType = "image",
}) => {
  return (
    <Container orientation={orientation}>
      <ImageFrame>
        {imageUrl ? (
          <ContentImage src={imageUrl} alt={title || "uploaded image"} />
        ) : (
          <Placeholder>이미지 URL이 없습니다</Placeholder>
        )}
      </ImageFrame>
    </Container>
  );
};

export default MoleculeImageContentInfoBoard;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ImageFrame = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const ContentImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Placeholder = styled.div`
  color: #888;
  font-size: 16px;
`;